export enum AuthModals {
  MainModal = "MainModal",
  Login = "Login",
  SetEmail = "SetEmail",
  PinCode = "PinCode",
  NewPassword = "NewPassword",
  RegEmail = "RegEmail",
  RegPassword = "RegPassword",
  RegCode = "RegCode",
  WebHeader = "WebHeader",
}

export  interface ValidationResult {
  isValid: boolean;
  error: string | null;
}
